import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddPersonRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10 10.5a2.5 2.5 0 1 0 .001-4.999A2.5 2.5 0 0 0 10 10.5M10 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8M8.5 15a4 4 0 0 0-4 4v.25c0 .416-.334.75-.75.75a.75.75 0 0 1-.75-.75V19a5.5 5.5 0 0 1 5.5-5.5h3A5.5 5.5 0 0 1 17 19v.25c0 .416-.334.75-.75.75a.75.75 0 0 1-.75-.75V19a4 4 0 0 0-4-4zM19 7c.416 0 .75.334.75.75v1.5h1.5c.416 0 .75.334.75.75s-.334.75-.75.75h-1.5v1.5c0 .416-.334.75-.75.75a.75.75 0 0 1-.75-.75v-1.5h-1.5A.75.75 0 0 1 16 10c0-.416.334-.75.75-.75h1.5v-1.5c0-.416.334-.75.75-.75" })
});
export default SvgAddPersonRegularIcon;
